import React, {useState, useEffect} from "react";
import { useNavigate, useSearchParams, createSearchParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Quiz from './partials/Quiz';
import Header from "./layouts/Header";
import Loading from "./Loading";
import { getViewInstance } from "../actions/viewinstance";
import Slide from '@mui/material/Slide'
import Grid from '@mui/material/Grid'
import { Progress } from 'react-sweet-progress';



// This holds the page content for the assessments
// In the future, this could be what we embed in other websites

//let theme = null

const QuestionPrompts = {
    "Month": "Month",
    "Day": "Day",
    "Year": "Year",
    "Dropdown": "Please Select",
    "HeightPrimary": "Feet",
    "HeightSecondary": "Inches",
    "MonthSQL": [
      {
        "MonthId": "5",
        "MonthName": "January",
        "MonthSequenceInYear": "1",
        "MonthAbbreviation": "Jan",
        "MonthSequenceInYearCode": "01",
        "StandardContent": "January"
      },
      {
        "MonthId": "6",
        "MonthName": "February",
        "MonthSequenceInYear": "2",
        "MonthAbbreviation": "Feb",
        "MonthSequenceInYearCode": "02",
        "StandardContent": "February"
      },
      {
        "MonthId": "7",
        "MonthName": "March",
        "MonthSequenceInYear": "3",
        "MonthAbbreviation": "Mar",
        "MonthSequenceInYearCode": "03",
        "StandardContent": "March"
      },
      {
        "MonthId": "8",
        "MonthName": "April",
        "MonthSequenceInYear": "4",
        "MonthAbbreviation": "Apr",
        "MonthSequenceInYearCode": "04",
        "StandardContent": "April"
      },
      {
        "MonthId": "9",
        "MonthName": "May",
        "MonthSequenceInYear": "5",
        "MonthAbbreviation": "May",
        "MonthSequenceInYearCode": "05",
        "StandardContent": "May"
      },
      {
        "MonthId": "10",
        "MonthName": "June",
        "MonthSequenceInYear": "6",
        "MonthAbbreviation": "Jun",
        "MonthSequenceInYearCode": "06",
        "StandardContent": "June"
      },
      {
        "MonthId": "11",
        "MonthName": "July",
        "MonthSequenceInYear": "7",
        "MonthAbbreviation": "Jul",
        "MonthSequenceInYearCode": "07",
        "StandardContent": "July"
      },
      {
        "MonthId": "12",
        "MonthName": "August",
        "MonthSequenceInYear": "8",
        "MonthAbbreviation": "Aug",
        "MonthSequenceInYearCode": "08",
        "StandardContent": "August"
      },
      {
        "MonthId": "13",
        "MonthName": "September",
        "MonthSequenceInYear": "9",
        "MonthAbbreviation": "Sep",
        "MonthSequenceInYearCode": "09",
        "StandardContent": "September"
      },
      {
        "MonthId": "14",
        "MonthName": "October",
        "MonthSequenceInYear": "10",
        "MonthAbbreviation": "Oct",
        "MonthSequenceInYearCode": "10",
        "StandardContent": "October"
      },
      {
        "MonthId": "15",
        "MonthName": "November",
        "MonthSequenceInYear": "11",
        "MonthAbbreviation": "Nov",
        "MonthSequenceInYearCode": "11",
        "StandardContent": "November"
      },
      {
        "MonthId": "16",
        "MonthName": "December",
        "MonthSequenceInYear": "12",
        "MonthAbbreviation": "Dec",
        "MonthSequenceInYearCode": "12",
        "StandardContent": "December"
      }
    ]
  }

  const ValidationMessages = {
    HeightOutOfRange: "Height out of Range",
InvalidAgeTooOld: "This assessment was designed for those <number> years of age or younger",
InvalidAgeTooYoung: "This assessment was designed for those <number> years of age or older",
InvalidDate: "Invalid Date",
InvalidPrecision: "Too many digits of precision",
NotANumber: "Must be a number",
OutOfRange: "Must be between <low> and <high>",
WholeNumbers: "Only whole numbers"
}

const HRA = (props) => {

    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const [searchParams, setSearchParams] = useSearchParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [quizState, setQuizState] = useState({
        Questions: [],
          Username: '',
          AuthToken: '',
          ParticipantGuid: '',
          ResponseGuid: '',
          QuizsDirection:'left',
          QuestionsAnswered: 0,
          QuestionTotal: 1,
          UnitOfMeasure:'IMPERIAL',
          LoadingError: false,
          ErrorViewInstance: [],
          isTimedOut: false,
          CurrentIndex: 0,
          StartingAssessment: false
    })

        /*this.timer = null;
        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this) */

        useEffect(() => {
            if(!callVI && (!viewInstance || !viewInstance.SurveyPage) && currentUser && currentUser.AuthToken){
              setCallVI(true);
              let vi = searchParams.get('vi')
              dispatch(getViewInstance('38E01F8C-5C38-423D-8573-23E1BEC87C88',currentUser.AuthToken))
            }
          }, [location.pathname])

        useEffect(() => {
            //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
            if((!quizState.Questions.length && !quizState.StartingAssessment && settings)){
                setQuizState({...quizState, StartingAssessment: true})
                getAssmtGuid()
            }
            //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
          }, [viewInstance, settings]) 

   //useEffect(() => {
   //    if(!quizState.ResponseGuid.length){
   //        getAssmtGuid()
   //    }
   //    //this.setState({
   //    //    timeout: this.props.timeout
   //    //})
   //    //this.setClientColor(this.props.clientColor)
   //})

    //************************* */

    const getAssmtGuid = () => {
        let responseGuid = ''
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + settings.SessionVariableValues["PERSON GUID"] +'/ASSMT%20PRODUCT%20GUID/59515E4C-FF98-4A98-BA32-B60BA8B6011F/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }})
        .then(response => response.json())
        .then(response => {
            if(response.Success){
                fetch('../../WsWebServicePlatform/Participant/SessionVar/Get/' + currentUser.AuthToken + '/RESPONSE%20GUID')
                .then(response=>response.json())
                .then(response=>{
                    if(!response.Info.length){
                        
                        fetch('../../WsWebServiceHra/StartAssessment/' + currentUser.AuthToken + '/' + '59515E4C-FF98-4A98-BA32-B60BA8B6011F' + '/',
                                    {
                                    method:'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: {

                                    }
                        })
                        .then(response => response.json())
                        .then(response=>{
                            getQuestions(response.Info[0].AssmtGuid)
                            setQuizState({...quizState, 
                                ResponseGuid: response.Info[0].AssmtGuid,
                                StartingAssessment: false
                            })
                            storeAssmtGuidToSession(response.Info[0].AssmtGuid)
                            //setSearchParams('assmtGuid', response.Info[0].AssmtGuid)
                        })
                    }
                        
                    else {
                        responseGuid = response.Info[0].Value
                        getQuestions(responseGuid)
                        setQuizState({...quizState, 
                            ResponseGuid: responseGuid, 
                            StartingAssessment: false})
                        //storeAssmtGuidToSession(response.Info[0].Value)
                        //setSearchParams('assmtGuid', response.Info[0].Value)
                        //this is for test login and othe rpages that send assmtGuid through session
                    }
                })
                }
                
        })
    }

    useEffect(() => {
    }, quizState.ResponseGuid) 

    const storeAssmtGuidToSession = (assmtGuid) => {
        if(searchParams.get("asAuthToken")){
            fetch("../../WsWebServicePlatform/Participant/SessionVar/Set/" + assmtGuid + '/RESPONSE%20GUID/' + searchParams.get('asAuthToken'), {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
        } else {
            fetch("../../WsWebServicePlatform/Participant/SessionVar/Set/" + assmtGuid + '/RESPONSE%20GUID/' + currentUser.AuthToken, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
        }
    }

    const getQuestions = (responseGuid) => {
        fetch('../../WsWebServiceWellSuite/GetViewInstance/' + currentUser.AuthToken + '/8C292A8F-C14E-470B-A164-015F1CB2E2DD/',
        {
            method:'GET',
            headers:{
                'Accept': 'application/json'
            }
        })
    .then(response=>response.json())
    .then(response=>{
        setQuizState({...quizState, 
            Questions: response.Info[0].ViewInstanceData[0].SurveyPage,
            StartFromBeginning: true,
            ResponseGuid: responseGuid,
            UnitOfMeasure: response.Info[0].ViewInstanceData[1].SessionVariableValues["UNIT OF MEASURE"]
        })
    })
    }

    /*setClientColor(clientColor){
        theme = createMuiTheme({
        palette: {
            primary: {
                main: clientColor
            }
        }
    })} */

    const updateValues = (vars) => {
        setQuizState({...quizState, 
            Username: vars.UserName,
            AuthToken: vars.AuthToken,
            ParticipantGuid: vars.ParticipantGuid
        })
    }

    useEffect(() => {
    },[quizState.Questions])

    
    //use this for continue
    const setCurrentIndex = (index) => {
        setQuizState({...quizState, 
        CurrentIndex: index
      })
    }

    const updateQuestionsAnswered = (num, currentIndex) => {
        setQuizState({...quizState, 
            QuestionsAnswered: num
        })
    }

    const updateQuestionTotal = (num) => {
        setQuizState({...quizState, 
            QuestionTotal: num
        })
    }

    const completeSuccessful = (didCompleteSuccessfully) => {
        if(didCompleteSuccessfully){
            navigate({pathname: '/personalreport', search: createSearchParams({vi: '8AC17D1E-2871-44D9-ACC0-867285149337', assmtguid: currentUser.AuthToken }).toString()})
                
        }
    }

    if(quizState.Questions.SurveyData && quizState.ResponseGuid){
        let progressBar 
        let status='active'
        
            if(quizState.QuestionsAnswered == quizState.QuestionTotal){
                status = 'success'
                
            } else {
                status = 'active'

            }
                progressBar = <Grid item xs={12} style={{margin:'-10px 0 10px 0'}}>
                                <Progress theme={{
                                            active: {
                                              color: 'green'
                                            },
                                            default: {
                                              color: 'red'
                                            }
                                          }} 
                                    status={status} percent={Math.floor((quizState.CurrentIndex)/quizState.Questions.SurveyData[0].QuestionSetQuestionSet.length*100)} />
                              </Grid>

            return (
                <div>
                    <Header clientheader={viewInstance.HomePage.ClientLogo} menu={viewInstance.HomePage.NavigationMenuHome} />
                    <div style={{marginTop: '150px'}}>
                    {progressBar}
                    <Slide in={true} direction={quizState.QuizsDirection} mountOnEnter unmountOnExit timeout={300}>
                    <Quiz 
                            questions={quizState.Questions}
                            authtoken={currentUser.AuthToken}
                            responseguid={quizState.ResponseGuid}
                            startfromBeginning={quizState.StartFromBeginning}
                            uom={quizState.UnitOfMeasure}
                            validationMessages={ValidationMessages}
                            questionPrompts={QuestionPrompts}
                            updateQuestionTotal={updateQuestionTotal}
                            updateQuestionsAnswered={updateQuestionsAnswered}
                            setCurrentIndex={setCurrentIndex} 
                            completeSuccessful={completeSuccessful}/>
                    
                    </Slide>
                    </div>
                    
                </div>
        )
    } else return <Loading />
        
}
//<QuizResults results={NewPRViewInstance TestResultsViewInstance this.state.ResultsViewInstance} userEmail={this.state.userEmail}/>
// <QuizResults results={TestResultsViewInstance} userEmail={this.state.userEmail} clientLogo = {this.props.ClientLogo} name={this.props.HeaderFrame.Name} groupguid={'16fef634-1d70-4962-b452-1f13f3a561a7'} authtoken={'B043AE45-3828-4407-8F0B-330B768E5A5E'}/>
                        
//<Slide >
//                    {content}
//                </Slide> 
export default HRA;